import React from 'react'
import { ParallaxLayer } from '@react-spring/parallax'
import './style.scss'
import { aboutMeContent } from './predeterminedConstant'
import ScrollComponents from '../../../widgets/scrollComponents'

function HomeIntroduction() {
  return (
    <div className={'intro-container'}>
    { 
      aboutMeContent.map((content) => 
        <ParallaxLayer offset={content.offset} className={'intro-content-placeholder'}>
          <ScrollComponents springConfig={content.springConfig} className={'intro-content-container'}>
            { content.content }
          </ScrollComponents>
        </ParallaxLayer>
      )
    }
    </div>
  )
}

export default HomeIntroduction
